import PropTypes from "prop-types";
import React from "react";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl, FormattedHTMLMessage } from "react-intl";
import { TextDisplay } from "components/display-data";
import Timeline, { getValidLayouts } from "components/timeline";
import ScreenPosition from "components/screen-position";
import { getElementsVisibleOnMixer } from "pages/graphicset/utils";

const GraphicSetData = ({ graphicSet, intl }) => {
  const validLayouts = getValidLayouts(graphicSet.layouts);
  const showTimeline =
    validLayouts && validLayouts.length > 0 && graphicSet.schedules && graphicSet.schedules.length > 0;

  return !graphicSet ? null : (
    <DataGrid>
      <DataGridItem>
        <TextDisplay label={intl.formatMessage({ id: "common.name" })}>{graphicSet.name}</TextDisplay>
      </DataGridItem>
      <DataGridItem>
        <TextDisplay label={intl.formatMessage({ id: "common.description" })}>{graphicSet.description}</TextDisplay>
      </DataGridItem>
      <DataGridItem big>
        <FormattedHTMLMessage
          id="graphicset.mixer.slot.error"
          values={{
            slots: getElementsVisibleOnMixer(graphicSet),
          }}
        />
      </DataGridItem>
      {showTimeline && (
        <DataGridItem big>
          {graphicSet.schedules.map(currentSchedule => (
            <Timeline
              key={currentSchedule.type}
              displayOnly
              currentSchedule={currentSchedule}
              schedules={graphicSet.schedules}
              layouts={graphicSet.layouts}
              customerId={graphicSet.customerId}
            />
          ))}
        </DataGridItem>
      )}
      {!showTimeline && (
        <DataGridItem big>
          <ScreenPosition layouts={graphicSet.layouts} />
        </DataGridItem>
      )}

      {graphicSet.schedules &&
        graphicSet.schedules.map(schedule => (
          <DataGrid big key={schedule.type}>
            <DataGridItem>
              <TextDisplay showIfEmpty label={intl.formatMessage({ id: "graphicset.schedule.type" })}>
                {schedule.type}
              </TextDisplay>
            </DataGridItem>
            <DataGridItem>
              <TextDisplay showIfEmpty label={intl.formatMessage({ id: "graphicset.schedule.period" })}>
                {schedule.period}
              </TextDisplay>
            </DataGridItem>
          </DataGrid>
        ))}
    </DataGrid>
  );
};

GraphicSetData.propTypes = {
  /**
   * Data to represent
   **/
  graphicSet: PropTypes.object,
};

export default injectIntl(GraphicSetData);
